import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgList = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M9 6l11 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 12l11 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 18l11 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 6l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 12l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 18l0 .01" })
	]
});
const ForwardRef = forwardRef(SvgList);
export default ForwardRef;
